// initial state
const state = {
    data: null
}

// getters
const getters = {
    loggedIn: state => state.data != null,
    userId: state => state.data && state.data.id,
    featureFlags: state => (state.data && state.data.feature_flags) || [],
    isVerified: state => state.data && state.data.email_verified
}

// actions
const actions = {
    logOut: ({commit}) => commit('logOut'),
    async getDetails({commit}, caller) {
        let data = await caller.get('/api/users/me/')
        await commit('setDetails', data)
    }
}

// mutations
const mutations = {
    logOut(state) {
        state.data = null
    },
    setDetails(state, data) {
        state.data = {...data}
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
